import Header from "@/components/Header";
import Hero from "@/components/Hero";
import QualitativeApproach from "@/components/QualitativeApproach";
import About from "@/components/About";
import HowWeWork from "@/components/HowWeWork";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import AnalysisSection from "@/components/AnalysisSection";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { packageTerms } from "@/data/linkBuildingPackages";
import CompanyFacts from "@/components/CompanyFacts";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Quality Backlinks & Link Building Services | Linkzy"
        description={`Quality backlinks from real, traffic-verified websites. Guest post packages from $${packageTerms[0].price.toLocaleString("en-US")} USD, content included. Request free sample sites.`}
        keywords="b2b link building, saas link building, quality backlinks, backlinks, link building services, SEO backlinks, guest posting, niche edits, high authority links"
        url="/"
        image="https://hvqhozgnhtmmcxixltnt.supabase.co/storage/v1/object/public/blog-images/linkzy-og-default.png"
        imageAlt="Linkzy — quality backlinks for B2B brands"
      />
      <Header />
      <main>
        <Hero />
        <QualitativeApproach />
        <About />
        <HowWeWork />
        <TestimonialsSection />
        <FAQSection />
        <CompanyFacts />
        <AnalysisSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
